import { buildRouteUrl } from './routes.js';

export function updatePageMeta(route, viewEl) {
  if (!viewEl) {
    return;
  }

  const title = viewEl.getAttribute('data-route-title') || '';
  const description = viewEl.getAttribute('data-route-description') || '';
  const canonicalUrl = window.location.origin + buildRouteUrl(route);

  if (title) {
    document.title = title;
  }

  const descriptionMeta = document.querySelector('meta[name="description"]');
  if (descriptionMeta) {
    descriptionMeta.setAttribute('content', description);
  }

  const ogTitle = document.querySelector('meta[property="og:title"]');
  if (ogTitle) {
    ogTitle.setAttribute('content', title);
  }

  const ogDescription = document.querySelector('meta[property="og:description"]');
  if (ogDescription) {
    ogDescription.setAttribute('content', description);
  }

  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.setAttribute('content', canonicalUrl);
  }

  const appleTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
  if (appleTitle) {
    appleTitle.setAttribute('content', title);
  }

  const appTitle = document.querySelector('meta[name="application-name"]');
  if (appTitle) {
    appTitle.setAttribute('content', title);
  }

  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute('href', canonicalUrl);
  }
}
